import React from 'react';
import "./HomePage.css";


function ReviewCard(props) {

  return (
    <>
    <div className="reviewCardContainer" style={{backgroundColor:"#141414"}}>
      <div className="reviewCardContainer2">

      <div className="reviewContainer" style={{color:"#ffffff"}}>
        <p className="review">{props.review}</p>
      </div>

      <div className="personDetails" style={{color:"#ffffff", display:"flex"}}>
        <div style = {{alignSelf:"end"}}>
          <h2 className="personName"><strong>{props.name}</strong></h2>
        </div> 
      </div>

      </div>
    </div>
    </>
  )
}

export default ReviewCard;